export const homePageUrl = process.env.REACT_APP_HOME_PAGE_URL || "";
export const getAppUrl = process.env.REACT_APP_GET_APP_URL || "";
export const policyUrl = process.env.REACT_APP_POLICY_URL || "";
export const termsUrl = process.env.REACT_APP_TERMS_URL || "";
export const kinkeeperEmail = process.env.REACT_APP_KNK_EMAIL || "";
export const kinkeeperTemporaryShare =
  process.env.REACT_APP_TEMPORARY_SHARE_ORIGIN_URL || "";
export const VERIFY_PIN_ENDPOINT = "/v1/user/verify-pin";
